import { render, staticRenderFns } from "./UnitsSelector.vue?vue&type=template&id=0c71a796&"
import script from "./UnitsSelector.vue?vue&type=script&lang=js&"
export * from "./UnitsSelector.vue?vue&type=script&lang=js&"
import style0 from "./UnitsSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports